import axios from 'axios';

import {
  setRefundList,
  getRefundDetail,
  getPassword,
  updateRefund,
  exportRefund,
} from '../../../../Redux/refund/refundSlice';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setUserData } from '../../../../Redux/user/userSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

export const fetchStoreRefundsList = async ({ params, dispatch }) => {
  params.type = 'store'; // Add this line to include the store refund filter
  //params.store_id = UserStore;
  console.log('Fetch Store Refunds with params:', params);
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/allrefund-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setRefundList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
    // this loader added because in case order not returned the success message
  }
};

// Function to update refund status
export const updateRefundStatus = async ({ refund_id, status, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/oms-service/update-refund-status`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      refund_id,
      status,
    },
  };
  try {
    const response = await axios(config);
    // Optionally dispatch an action or handle response
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

export const generateCreditNoteToken = async ({ params }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/generate-credit-note-token`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
  }
};


